<template>
  <v-container
    style="max-width: 100vw;
    padding: 0;"
  >
    <iframe :src="frameSrc" style="width:100%; height:100vh;"> </iframe>
    <v-btn
      fab
      color="info"
      v-tooltip="'Ditandatangani oleh: XXX pada tanggal YYY'"
      style="position:absolute; z-index:100; bottom:20px; right:30px;"
    >
      <v-icon>mdi-information-variant</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    frameSrc: null,
  }),
  mounted() {
    // let ids = this.$route.params.id.split('-')
    this.frameSrc =
      this.$api.url + `/reports/sppd/signed/${this.$route.params.id}`
  },
}
</script>
